// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetSeoDataRequest, TGetSeoDataModel, IMappers, TGetSeoDataResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetSeoDataV1Response } from '../../entities/get_seo_data/GetSeoDataV1Response';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetSeoDataModel(parameters: TGetSeoDataRequest): TGetSeoDataModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'seo-urls',
    pathApi: '/v1/get-seo-data/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetSeoDataOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetSeoDataRequest;
}

export async function fetchGetSeoData<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetSeoDataOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetSeoDataResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetSeoDataModel(parameters),
    config,
  )) as FetchResponse<TGetSeoDataResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetSeoDataV1Response, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetSeoDataResponse>;
}
